<template>
    <div class="product-card">
        <div class="product-card-top">
            <a :href="comboUrl" class="product-image">
                <img :src="baseImage" :class="{ 'image-placeholder': ! hasBaseImage }" alt="combo image">
            </a>

            <div class="product-card-actions">
                <button
                    class="btn btn-wishlist"
                    :class="{ 'added': inWishlist }"
                    :title="$trans('storefront::combo_card.wishlist')"
                    @click="syncWishlist"
                >
                    <i class="la-heart" :class="inWishlist ? 'las' : 'lar'"></i>
                </button>

                <button
                    class="btn btn-compare"
                    :class="{ 'added': inCompareList }"
                    :title="$trans('storefront::combo_card.compare')"
                    @click="syncCompareList"
                >
                    <i class="las la-random"></i>
                </button>
            </div>

            <ul class="list-inline product-badge">
                <li class="badge badge-danger" v-if="combo.is_out_of_stock">
                    {{ $trans('storefront::combo_card.out_of_stock') }}
                </li>

                <li class="badge badge-primary" v-else-if="combo.is_new">
                    {{ $trans('storefront::combo_card.new') }}
                </li>

                <li class="badge badge-success" v-if="combo.has_percentage_special_price">
                    -{{ combo.special_price_percent }}%
                </li>
            </ul>
        </div>

        <div class="product-card-middle">
            <!-- <ComboRating :ratingPercent="combo.rating_percent" :reviewCount="combo.reviews.length"/> -->

            <a :href="comboUrl" class="product-name">
                <h6>{{ combo.name }}</h6>
            </a>

            <div class="product-price product-price-clone" v-html="combo.formatted_price"></div>
        </div>

        <div class="product-card-bottom">
            <div class="product-price" v-html="combo.formatted_price"></div>

            <button
                v-if="hasNoOption || combo.is_out_of_stock"
                class="btn btn-primary btn-add-to-cart"
                :class="{ 'btn-loading': addingToCart }"
                :disabled="combo.is_out_of_stock"
                @click="addToCart"
            >
                <i class="las la-cart-arrow-down"></i>
                {{ $trans('storefront::combo_card.add_to_cart') }}
            </button>

            <a
                v-else
                :href="comboUrl"
                class="btn btn-primary btn-add-to-cart"
            >
                <i class="las la-eye"></i>
                {{ $trans('storefront::combo_card.view_options') }}
            </a>
        </div>
    </div>
</template>

<script>
    /*import ComboRating from './ComboRating.vue';*/
    import ComboCardMixin from '../mixins/ComboCardMixin';

    export default {
        components: {  }, //ComboRating

        mixins: [
            ComboCardMixin,
        ],

        props: ['combo'],
    };
</script>
